import React, { useEffect, useState } from 'react';
import '../App.css';
import Layout from '../components/Layout';

const SmartOffice = () => {
  const [activeSection, setActiveSection] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const contentSections = [
    {
      title: '智慧党建系统',
      content: '学校智慧党建管理系统利用信息化管理技术，为校园内党组织发展提供了全流程学习和管理服务，实现了党建工作的信息化、智能化。系统集宣传、党务、考评、监督、党建数据于一体，结合信息终端为学校提供全面的管理功能，各党员也可通过即时同步党务信息的移动应用，享受便捷的党费缴纳、签到投票和党建学习等服务，充分发挥多端口、移动化的优势，强化各党组织之间的机制性联系，促进构建全区域统筹、多方面联动的校园智慧党建新格局。',
      img: <img src="/src/img/zhdj.png" alt="" />
    },
    {
      title: '协同办公系统',
      content: '实现公文的起草、审批、流转、归档等全流程管理，包括收文、发文、签报等，支持电子签名和审批痕迹保留。可定制各种审批流程，如请假、报销、采购等，方便教职工进行线上申请和审批。提供内部邮件功能，方便学校内部人员之间的沟通和信息传递。帮助用户安排个人或团队的工作日程，支持日程提醒和共享，发布学校的通知、公告等信息，确保教职工及时了解相关事项。',
      img: <img src="" alt="" />
    },
    {
      title: '访客管理系统',
      content: '系统围绕进出学校的人车，为学生家长提供微信小程序端、社会人员提供手机网页H5端、门岗提供访客管理端，满足访客现场扫码登记和网上预约申请2种应用场景，构建校园访客信息数据库，不仅方便家长及社会人员进出校园，还能提高访客管理与安全管理效率，长期保留来访档案记录。',
      img: <img src="/src/img/fkgl.png" alt="" />
    },
    {
      title: '车辆管理系统',
      content: '车辆进出校门智能识别管理系统融合了校门信息管理、车辆白名单管理、车辆出入管理等多个子模块，实现车辆出入信息智能甄别，实时记录车辆出入信息，同时可提供闸机及道闸远程管控等服务，全面构建安全、可追溯的校园车辆出入管理体系，筑建平安校园。',
      img: <img src="/src/img/clgl.png" alt="" />
    },
    {
      title: '报修管理系统',
      content: '报修管理系统是一个用于管理学校内各种报修事务的信息化系统，它可以提高报修效率、优化维修流程，并方便学校对后勤维修工作进行管理和统计。由管理人员将学校内的公用设施、教学设备等资产进行登记录入，已注册的设施设备进行报修。报修人员登录系统后，填写报修物品、故障描述、报修地点等详细信息进行报修。管理人员接收到报修单后，进行审批并派工给相应的维修人员。维修人员可以查看自己的维修任务，记录维修过程、维修时间和维修结果等。',
      img: <img src="" alt="" />
    },
    {
      title: '预约管理系统',
      content: '预约管理系统是用于管理学校内各种预约事务的信息化系统。如学生、教师、管理员等进行预约，并设置相应权限。用户可以提交预约请求，如实验室预约、场地预约、活动预约、课程预约等，需填写相关信息，如预约项目、时间、地点、人员等。系统自动显示可用的预约时间段，合理安排预约，避免冲突。部分预约可能需要相关人员进行审批，审批结果实时通知申请人。',
      img: <img src="" alt="" />
    },
    {
      title: '会议管理系统',
      content: '无纸化会议是采用现代信息技术建设的智慧会议管理系统。以电脑、平板等设备为载体。以会议文件为核心，通过文件的电子交换实现会议的无纸化，节约资源，减少纸张消耗。基于一体化会议平台，清楚此会议的开展情况以及落实情况。覆盖会议方案、会议通知、会议纪要以及督办和任务等。一键查看会议全貌，会议与公文、督办、事务、任务等贯通。',
      img: <img src="/src/img/hygl.png" alt="" />
    }
  ];

  const handleSectionChange = (index) => {
    setActiveSection(index);
  };

  return (
    <Layout>
      <div className="page-header" style={{ 
        backgroundImage: 'url("/src/img/zhmkt.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '300px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '20px'
      }}>
        <h1 style={{ 
          color: '#fff',
          fontSize: '2.5rem',
          fontWeight: 'bold',
          textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
        }}>智慧办公系统</h1>
      </div>
      <div className="page-container">
        <div className="page-layout">
          <div className="left-menu">
            {contentSections.map((section, index) => (
              <div
                key={index}
                className={`menu-item ${activeSection === index ? 'active' : ''}`}
                onClick={() => handleSectionChange(index)}
              >
                {section.title}
              </div>
            ))}
          </div>
          <div className="content-section">
            <div className="section-header" style={{
              padding: '20px 40px',
              marginBottom: '30px'
            }}>
              <h3 style={{
                fontSize: '1.2rem',
                lineHeight: '1.6',
                color: '#333',
                textIndent: '2em'
              }}>{contentSections[activeSection].content}</h3>
            </div>
            <div className="office-content">
              <div className="office-features" style={{ display: 'flex', justifyContent: 'center', height: '500px', marginBottom: '40px' }}>
                <div style={{ width: '1000px', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
                  {contentSections[activeSection].img && React.cloneElement(contentSections[activeSection].img, {
                    style: { width: '100%', height: '100%', objectFit: 'contain' }
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SmartOffice;